import request from '@/router/axios';
export const add = (row) => {
  return request({
    url: '/api/produce/produce-schedule/insert',
    method: 'post',
    data: row
  })
}
export const update = (row) => {
  return request({
    url: '/api/produce/produce-schedule/update',
    method: 'post',
    data: row
  })
}
export const getDetail = (id) => {
  return request({
    url: '/api/produce/produce-schedule/select/id',
    method: 'get',
    params: {
      id
    }
  })
}
export const getList = (params) => {
  return request({
    url: '/api/produce/produce-schedule/select/page',
    method: 'get',
    params
  })
}
export const remove = (ids) => {
  return request({
    url: '/api/produce/produce-schedule/delete/ids',
    method: 'get',
    params: {
      ids
    }
  })
}

export const confirm = (id, ext) => {
  return request({
    url: '/api/produce/produce-schedule/confirm',
    method: 'post',
    data: {
      id,
      ext
    }
  })
}

// 获取仓库列表
export const getStoreList = (planNo) => {
  return request({
    url: '/api/produce/store/select/distinct/pycode',
    method: 'post',
    data: {planNo}
  })
}

// 获取库位列表
export const getLocationList = (storeNo,planNo) => {
  return request({
    url: '/api/produce/store-sub/select/getLocationByStoreNo',
    method: 'get',
    params: {
      storeNo,
      planNo
    }
  })
}

